import { useTranslation } from "react-i18next";

export default function AccessDenied() {
  const { t } = useTranslation();

  return <div className="p-6">{t("noPermissions")}</div>;
}
